import { SupplierForm } from "./SupplierForm";
import { useParams } from "react-router";

export const CreateSupplierPage = () => {
    const { startingPageId } = useParams();

    return <SupplierForm startingPageId={startingPageId ?? "0"} />;
};
